export default __webpack_public_path__ + "static/media/imone-icon-active.e8677f52.svg";